<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h1>Alteração Salarial do Funcionário</h1>
    <button type="button" class="btn btn-secondary" (click)="voltar()">Voltar</button>
  </div>
  <hr />

  <div class="card mb-4" *ngIf="funcionario as f">
    <div class="card-body">
      <h5 class="card-title">Dados do Funcionário</h5>
      <div class="row">
        <div class="col-md-4"><strong>ID:</strong> {{ f.id }}</div>
        <div class="col-md-4"><strong>Nome:</strong> {{ f.nome }} {{ f.sobrenome }}</div>
        <div class="col-md-4"><strong>Cargo Atual:</strong> {{ f.cargoDescricao }}</div>
      </div>
    </div>
  </div>

  <div class="card mb-4">
    <div class="card-body">
      <h5 class="card-title">Nova Alteração</h5>
      <form [formGroup]="historicoForm" (ngSubmit)="salvarHistorico()">
        <div class="row">
          <div class="col-md-4 mb-3">
            <label for="idCargo" class="form-label">Cargo *</label>
            <select id="idCargo" class="form-control" formControlName="idCargo">
              <option [ngValue]="null">Selecione um cargo</option>
              <option *ngFor="let cargo of cargos" [ngValue]="cargo.id">{{ cargo.descricao }}</option>
            </select>
          </div>

          <div class="col-md-4 mb-3">
            <label for="salario" class="form-label">Salário *</label>
            <input type="number" id="salario" class="form-control" formControlName="salario" min="0" step="0.01" />
          </div>

          <div class="col-md-4 mb-3">
            <label for="dataAtualizacao" class="form-label">Data da Atualização *</label>
            <input type="datetime-local" id="dataAtualizacao" class="form-control" formControlName="dataAtualizacao" />
          </div>

          <div class="col-md-12 mb-3">
            <label for="motivoMudanca" class="form-label">Motivo da Mudança *</label>
            <textarea id="motivoMudanca" class="form-control" rows="3" formControlName="motivoMudanca"></textarea>
          </div>
        </div>

        <button type="submit" class="btn btn-primary" [disabled]="isLoading">
          {{ isLoading ? 'Salvando...' : 'Salvar alteração' }}
        </button>
      </form>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Histórico de Alterações</h5>
      <div class="table-responsive">
        <table class="table table-striped table-hover mb-0">
          <thead>
            <tr>
              <th>ID</th>
              <th>Data</th>
              <th>Cargo</th>
              <th>Salário</th>
              <th>Motivo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of historico">
              <td>{{ item.id }}</td>
              <td>{{ item.dataAtualizacao | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ getCargoDescricao(item.idCargo) }}</td>
              <td>{{ item.salario | currency:'BRL'}}</td>
              <td>{{ item.motivoMudanca }}</td>
            </tr>
            <tr *ngIf="historico.length === 0">
              <td colspan="5" class="text-center text-muted">Nenhuma alteração salarial cadastrada.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>